import type {
  IBasicAuthState,
  IUserBasicInfo,
  LoginResponse,
} from "~/types/auth";

export const useAuth = () => {
  const authState = useState<IBasicAuthState>("auth", () => ({
    accessToken: null,
    user: null,
  }));

  const setAccessToken = (token: string) => {
    authState.value.accessToken = token;
  };

  const setUser = (user: IUserBasicInfo) => {
    authState.value.user = user;
  };

  const setAuth = (authData?: LoginResponse) => {
    if (isServerSide()) {
      return null;
    }

    if (isNil(authData)) {
      return;
    }

    authState.value = {
      accessToken: authData.authTokens?.access as string,
      user: authData.user,
    };
  };

  const clear = () => {
    authState.value.accessToken = null;
    authState.value.user = null;
  };

  const loggedIn = computed(() => {
    return !!authState.value.accessToken && !!authState.value.user;
  });

  return {
    accessToken: computed(() => authState.value.accessToken),
    user: computed(() => authState.value.user),
    loggedIn,
    setAccessToken,
    setUser,
    clear,
    setAuth,
  };
};
